module.exports = __webpack_public_path__ + "img/dace.b34dec56.png";